"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NicheGroupType = exports.AvailableStates = void 0;
var AvailableStates;
(function (AvailableStates) {
    AvailableStates["ES"] = "ES";
    AvailableStates["SP"] = "SP";
    AvailableStates["MG"] = "MG";
    AvailableStates["RJ"] = "RJ";
})(AvailableStates = exports.AvailableStates || (exports.AvailableStates = {}));
var NicheGroupType;
(function (NicheGroupType) {
    NicheGroupType["ADMIN"] = "ADMIN";
    NicheGroupType["ESTET"] = "ESTET";
    NicheGroupType["CONSTRUC"] = "CONSTRUC";
    NicheGroupType["SAUDE"] = "SAUDE";
    NicheGroupType["SEGUR"] = "SEGUR";
    NicheGroupType["VEND"] = "VEND";
    NicheGroupType["OUTR"] = "OUTR";
    NicheGroupType["SELECIONE"] = "SELECIONE";
})(NicheGroupType = exports.NicheGroupType || (exports.NicheGroupType = {}));
//# sourceMappingURL=group.types.js.map